
/**
 * @param {{commonHeader:string}} data
 */
import React, { useEffect, useState } from "react";
import { fetchCountdownCalendar } from "../../api/cms";
import CountdownCalendar from '../../components/CountdownCalendar';
import '../../components/CountdownCalendar/styles.scss';
import './styles.scss';

const CountdownCalendarEmbed: React.FC<any> = ({ pathAlias = null }) => {
  const [isLoaded, setIsLoaded] = useState(false);
  const [data, setData] = useState<any[]>([]);
  const [dataError, setDataError] = useState(false);
  const [countdowncalendarNid, setCountdowncalendarNid] = useState<any>({});
  const [countdowncalendarAlias, setCountdowncalendarAlias] = useState<any>({});

  useEffect(() => {
    const fetchData = async () => {
      // Get value from countdownCalendarApp first if does not exists check url param.
      let urlParam = pathAlias !== null ? pathAlias : '';
      const _data = await fetchCountdownCalendar(urlParam);

      // Validation for empty array or error message.
      // API returns error as true or empty array.
      if (_data.error === true || _data.length === 0) {
        setDataError(true);
        return;
      }
      else {
        setIsLoaded(true);
        setData(_data);
        // Set values for alias/nid to proper id component.
        setCountdowncalendarAlias(urlParam);
        setCountdowncalendarNid(_data.nid);
      }
    };

    fetchData();

  }, [pathAlias]);

  return (
    <>
      { (!dataError) ? (
        <div id={`countdown-calendar-embed-${countdowncalendarAlias}`} data-alias={countdowncalendarAlias} className="countdown-calendar-embed wof-react-component remove-bg">
          {isLoaded && data &&  <CountdownCalendar {...data} />}
        </div>
        ) : (
          <div>No countdown found.</div>
        )
      }
    </>
  );
}

export default CountdownCalendarEmbed;
